// extracted by mini-css-extract-plugin
export default {"title":"UserReviewsList-title","list":"UserReviewsList-list"};